import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './HomeRetail.css';

const deals = [
  {
    title: 'Under $25 finds',
    subtitle: 'Everyday essentials',
    image: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=600',
    to: '/shop?search=tee',
  },
  {
    title: 'Up to 40% off shoes',
    subtitle: 'Runners & everyday',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=600',
    to: '/category/shoes',
  },
  {
    title: 'Women’s new arrivals',
    subtitle: 'Fresh for the week',
    image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=600',
    to: '/category/women',
  },
  {
    title: 'Men’s denim edit',
    subtitle: 'Fits that move',
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=600',
    to: '/category/men',
  },
];

const HomeDeals = () => (
  <section className="home-deals" aria-labelledby="home-deals-heading">
    <div className="home-deals-inner">
      <div className="home-deals-header">
        <h2 id="home-deals-heading">Today’s top offers</h2>
        <Link to="/sale" className="home-deals-all">
          See all deals <ArrowRight size={16} />
        </Link>
      </div>
      <div className="home-deals-grid">
        {deals.map((deal, i) => (
          <Link
            key={deal.title}
            to={deal.to}
            className="home-deal"
            style={{ animationDelay: `${i * 0.06}s` }}
          >
            <img src={deal.image} alt="" className="home-deal-image" loading="lazy" />
            <div className="home-deal-copy">
              <h3>{deal.title}</h3>
              <p>{deal.subtitle}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default HomeDeals;
